//#region import
import React, { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Divider, Grid, Radio, Typography } from '@mui/material';
import { TextBoxItem } from 'components/Input/TextBox';
import { TextAreaItem } from 'components/Input/TextArea';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { useLocation, useNavigate } from 'react-router';
import { FnAxios, FnDialog } from 'utilities/utilities';
import { BtnBack, BtnSave } from 'components/Button/ButtonAll';
import { GetMenuPermission } from 'utilities/SystemFunction';
//#endregion

const RoleForm = () => {
    const navigate = useNavigate();
    const onBack = () => navigate("/RoleList");
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const [loadingTable, setLoadingTable] = useState(false);
    const location = useLocation();
    const searchParams = location.search;
    const sRoleID = new URLSearchParams(searchParams).get('sID');
    const [lstData, setLstData] = useState([]);

    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
    });
    const form = useForm({
        shouldFocusError: true,
        mode: "all"
    });
    const [isPermission, setPermission] = useState<boolean>(false); // Permission

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);

    const onSubmit = () => {
            let param = {
                sRoleID: sRoleID ?? "",
                sRoleName: form.getValues("sRoleName") ?? "",
                sDrescription: form.getValues("sDrescription") ?? "",
                lstPermission: dataRow.arrRows,
                sLocation: location.pathname
            };

            DialogFn.Submit(`คุณต้องการบันทึก ใช่หรือไม่ ?`, () => {
                DialogFn.BlockUI();
                AxiosFn.Post(`Role/SaveUserRole`, param, (result) => {
                    DialogFn.UnBlockUI();
                    DialogFn.Success(`บันทึกสำเร็จ`);
                    DialogFn.CloseSubmit()
                    navigate(`/RoleList`);
                }, (err) => {
                    DialogFn.UnBlockUI();
                    if (!err.response) {
                        DialogFn.Warning(err.sMessage);
                    }
                });
            });
        
    };

    const GetDataTable = async () => {
        let param = { sRoleID: sRoleID ?? "" };
        setLoadingTable(true);
        AxiosFn.Post(`Role/GetMenuRole`, param, (result) => {
            if (sRoleID) {
                form.setValue("sRoleName", result.sRoleName)
                form.setValue("sDrescription", result.sDrescription)
                form.setValue("isActive", result.isActive)
            }
            setLoadingTable(false);
            setLstData(result.lstPermission || [])
            setDataRow({
                ...dataRow,
                arrRows: result.lstPermission ?? [],
                nDataLength: result.ObjTable?.nDataLength,
                nPageIndex: result.ObjTable?.nPageIndex,
            });
        }, (err) => {
            if (!err.response) {
                DialogFn.Warning(err.Message);
            }
        }
        );
    };


    const dataColumn: any = [
        {
            field: "sNo",
            headerName: "ลำดับ",
            headerAlign: "center",
            align: "center",
            sortable: false,
            width: 60,
            disableColumnMenu: true,
            renderCell: (item) => {
                return (
                    <>
                        {item.row.nLevel == 1 &&
                            <Typography sx={{ fontWeight: 500,fontSize: 15 }}>{item.row.sNo} </Typography>
                        }
                        {item.row.nLevel == 2 &&
                            <Typography sx={{ fontSize: 15 }}>{item.row.sNo} </Typography>
                        }
                    </>
                )
            }
        },
        {
            field: "sMenuName",
            headerName: "เมนู / ฟังก์ชัน",
            headerAlign: "center",
            align: "Left",
            sortable: false,
            flex: 1,
            width: 250,
            disableColumnMenu: true,
            renderCell: (item) => {
                return (
                    <>
                        {item.row.nLevel == 1 &&
                            <Typography sx={{ fontWeight: 500 ,fontSize: 15 }}>{item.row.sMenuName} </Typography>
                        }
                        {item.row.nLevel == 2 &&
                            <Typography sx={{ fontSize: 15 }}>{item.row.sMenuName} </Typography>
                        }
                    </>
                )
            }
        },
        {
            field: "isDisable",
            headerName: `ปิดการมองเห็น`,
            headerAlign: "center",
            align: "center",
            resizable: false,
            sortable: false,
            minWidth: 200,
            disableColumnMenu: true,
            renderCell: (item) => {
                if (item.row.isDisableMenu) {
                    return (
                        <Radio checked={item.value}disabled={!isPermission} onChange={() => handleChangeRadio(item.row.sID, "isDisable")} />
                    )
                }
                else {
                    return <></>
                }

            }
        },
        {
            field: "isReadOnly",
            headerName: `เฉพาะการเข้าดู`,
            headerAlign: "center",
            align: "center",
            resizable: false,
            sortable: false,
            minWidth: 200,
            disableColumnMenu: true,
            renderCell: (item) => {
                if (item.row.isView) {
                    return (
                        <Radio checked={item.value} disabled={!isPermission} onChange={() => handleChangeRadio(item.row.sID, "isReadOnly")} />
                    )
                }
                else {
                    return <></>
                }
            }
        },
        {
            field: "isEnable",
            headerName: `เพิ่ม / แก้ไข / ลบ`,
            headerAlign: "center",
            align: "center",
            resizable: false,
            sortable: false,
            minWidth: 200,
            disableColumnMenu: true,
            renderCell: (item) => {
                if (item.row.isManage) {
                    return (
                        <Radio checked={item.value}disabled={!isPermission} onChange={() => handleChangeRadio(item.row.sID, "isEnable",)} />
                    )
                }
                else {
                    return (
                        <Grid item xs={12} md={12}  container spacing={1} justifyItems={'end'} justifyContent={'end'} style={{ margin: '5%', color: 'aliceblue'}}>.</Grid>
                    )
                }
            }
        }
    ];

    useEffect(() => {
        GetDataTable();
       
    }, [])

    const handleChangeRadio = (sID, sField) => {
        let latdata = dataRow.arrRows;
        let oCheck = latdata.find((f) => f.sID === sID);
        if (oCheck) {
            oCheck.isDisable = sField === "isDisable";
            oCheck.isReadOnly = sField === "isReadOnly";
            oCheck.isEnable = sField === "isEnable";
        }
        setDataRow({
            ...dataRow,
            arrRows: latdata ?? [],
            nDataLength:latdata.length,
        });
    };

    return (
        <React.Fragment>
            <FormProvider {...form}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <TextBoxItem
                            name="sRoleName"
                            label='ชื่อประเภทผู้มีสิทธิ์ใช้งานระบบ'
                            maxLength={150}
                            id={"sName"}
                            required={true}
                            type={'text'}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <TextAreaItem
                            placeholder=""
                            label='รายละเอียด'
                            name="sDrescription"
                            maxLength={1000}
                            id={"sDescription"}
                            disabled={!isPermission}
                            required={false}
                        />
                    </Grid>
                    {lstData.length > 0 &&
                        <Grid item xs={12} md={12}>
                            <Typography>
                                กำหนดสิทธิ์การใช้งาน
                                <span style={{ color: "red" }}> * </span>
                            </Typography>
                            <Divider />
                        </Grid>
                    }
                    {lstData.length > 0 &&
                        <Grid item xs={12} md={12}>
                            <DataGrid
                                isLoading={loadingTable}
                                columns={dataColumn}
                                rows={dataRow}
                                isHiddenToolHead={true}
                                isHiddenFooter={true}
                                isShowCheckBox={false}
                            />
                        </Grid>
                    }
                   
                   
                </Grid>
                <Grid container justifyContent="flex-start" sx={{ mt: 5 }}>
                    <Grid item xs={6} md={6}>
                        <BtnBack id={"btnBack"}  onClick={() => onBack()} />
                    </Grid>
                    
                    <Grid container item xs={6} md={6} justifyContent="flex-end">
                        <BtnSave
                        IsDisabled={!isPermission}
                        id={"btnSave"}
                            onClick={form.handleSubmit(
                                () => onSubmit(),
                                (err) => console.log("err", err)
                            )}
                        />
                    </Grid>
                </Grid>
            </FormProvider>
        </React.Fragment >
    )
}


export default RoleForm;

export const enum EnumPermission {
    Disable = 0,
    ReadOnly = 1,
    Enable = 2,
}